import * as yup from 'yup';

export const TWO_FACTOR_SCHEMA = yup.object().shape({
    identifier: yup.string().required(),
    token: yup.string().required(),
    remember: yup.boolean().default(false)
});
